import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import _ from 'lodash';
import { ClientLoggerService } from '../../../../services/client-logger.service';
import { PerformanceMetricsService } from '../../../../services/performance-metrics.service';
import { PerformanceContextService } from '../../../../services/performance-context.service';
import { DeviceDetectorService } from 'ngx-device-detector';

import { Farm, PerformanceContext } from '../../../../interfaces/mysynch.interfaces';

@Component({
    standalone: false,
    selector: 'tm-test-farms-view',
    templateUrl: '../app/pages/tm-dashboard/views/tm-test-farms-view/tm-test-farms-view.view.html',
    styleUrls: ['../app/pages/tm-dashboard/views/tm-test-farms-view/tm-test-farms-view.style.css']
    })
export class TMTestFarmsView implements OnInit , OnDestroy{
    
    private performanceContext: PerformanceContext | null = null;
    isMobile:boolean = false;
    loading:boolean = true;
    testFarms: any[] = [];

        constructor(@Inject('MySynchFactory') private MSF:any,
                    @Inject('ApiFactory') private api:any,
                    @Inject('CookieFactory') private cookies:any,
                    @Inject(PerformanceMetricsService) private perfMetricSvc:PerformanceMetricsService,
                    @Inject(PerformanceContextService) private perfContextSvc:PerformanceContextService,
                    @Inject(DeviceDetectorService) private deviceDetector:DeviceDetectorService,
                    @Inject(ClientLoggerService) private log:ClientLoggerService
        ){
            this.isMobile = this.deviceDetector.isMobile();
        }
    ngOnInit() {
        this.MSF.ready(() => {
            this.performanceContext = this.perfContextSvc.createPerformanceContext();
            this.perfMetricSvc.startTiming("Page:TerritoryManagementDashboardTestFarms:Render");

            this.loadReport().then(() => {
                this.perfMetricSvc.markPageReady("Page:TerritoryManagementDashboardTestFarms:Render", this.performanceContext);
                this.loading = false;
            });
        });
    }

    ngOnDestroy() {
        this.performanceContext = null;
    }

    testFarmsTrackFn = (index: number, farm: Farm): number => {
        return _.get(farm, 'farmId', index);
    }

    navigateToTestFarm(farm:Farm){
        var page = "KpiDashboard";
        var testFarmFarmId = _.get(farm,'farmId');
        var testFarmHerdId = _.get(farm,'herdId');

        this.MSF.loadPageForFarmId(page,testFarmHerdId,testFarmFarmId,true,'user',false,true); 
    }

    loadReport(){
        return new Promise<void>((resolve, reject) => {
            this.perfMetricSvc.startTiming("Page:TerritoryManagementDashboardTestFarmsPageData:Request");
            this.api.getAllActiveTestFarmsForTerritoryDashboard({}, this.performanceContext, (err:any, data:any) => {
                this.perfMetricSvc.endTiming("page","Page:TerritoryManagementDashboardTestFarmsPageData:Request", this.performanceContext);
                this.perfMetricSvc.startTiming("Page:TerritoryManagementDashboardTestFarms:Build");
                if (err) {
                    this.log.error(this.MSF.notify.danger('unable to get farms: ' + err));
                    this.testFarms = [];
                    resolve();
                    this.perfMetricSvc.endTiming("page","Page:TerritoryManagementDashboardTestFarms:Build", this.performanceContext);
                    this.loading = false;
                    return;
                }

                this.testFarms = _.cloneDeep(data);
                resolve();
                this.perfMetricSvc.endTiming("page","Page:TerritoryManagementDashboardTestFarms:Build", this.performanceContext);
               
            });
        });
    }
}